module.exports = __webpack_public_path__ + "img/28_24.f96fb878.png";